const baseUrl = 'https://api.bp-exch.com/api';

export default baseUrl;



// WEBPACK FOOTER //
// ./src/components/baseUrl.js